<template>
  <a
    :class="b({ visible })"
    href="#app"
    @click.prevent="onClickScrollToTop"
  >
    <e-icon-sprite
      :class="b('icon')"
      icon="i-chevron-2--up"
      size="24"
    />
    <div :class="b('label')">
      {{ $t('c-scroll-top.buttonTitle') }}
    </div>
  </a>
</template>

<script>
  import eIconSprite from '@/elements/e-icon-sprite.vue';

  const VIEWPORT_THRESHOLD = 0.5;

  /**
   * Renders a scroll to top button.
   */
  export default {
    name: 'c-scroll-top',
    components: {
      eIconSprite,
    },

    // mixins: [],

    // props: {},
    data() {
      return {
        /**
         * @type {Boolean} Holds the current visibility state of the button.
         */
        visible: false,

        /**
         * @type {Number} The timeout to hide the scroll to top button.
         */
        scrollActivityTimer: null,

        /**
         * @type {Number} Holds the previous y-position.
         */
        previousYPosition: null,
      };
    },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    mounted() {
      window.addEventListener('scroll', this.scrollListener, { passive: true });
    },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    beforeUnmount() {
      window.removeEventListener('scroll', this.scrollListener);
    },
    // unmounted() {},

    methods: {
      /**
       * Scrolls to top of page. JS variant was used to make sure scroll is not canceled by mouse.
       */
      onClickScrollToTop() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      },

      /**
       * Callback for the scroll event.
       */
      scrollListener() {
        const currentYPosition = window.pageYOffset;
        const isScrollingToTop = currentYPosition < this.previousYPosition;
        const isScrollPositionBiggerThanThreshold = currentYPosition > window.innerHeight * VIEWPORT_THRESHOLD;

        this.visible = isScrollingToTop && (isScrollPositionBiggerThanThreshold || this.visible);
        this.previousYPosition = currentYPosition;

        if (this.visible) {
          clearTimeout(this.scrollActivityTimer);

          this.scrollActivityTimer = setTimeout(
            () => {
              this.visible = false;
            },
            currentYPosition ? 3000 : 100,
          );
        }
      },
    },
    // render() {},
  };
</script>

<style lang="scss">
  @use 'sass:math';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  @use '@/setup/scss/extends' as *;

  .c-scroll-top {
    $default-size: variables.$font-size--64;

    @extend %button-reset;
    @extend %link--dark-blue;
    @include mixins.font-size($default-size);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 1em;
    height: 1em;
    opacity: 0;
    border-radius: 50%;
    background-color: variables.$color-grayscale--1000;
    box-shadow: functions.rem(0 functions.calc-em(2px 6px, $default-size)) rgba(variables.$color-grayscale--0, 0.2);
    color: variables.$color-primary--1;
    text-transform: uppercase;
    transition: opacity variables.$transition-duration--300;
    pointer-events: none;

    &__icon {
      width: functions.calc-em(24px, $default-size);
      height: functions.calc-em(24px, $default-size);
      margin-bottom: functions.calc-em(-3px, $default-size);
    }

    &__label {
      font-size: functions.calc-em(variables.$font-size--10, $default-size);
    }

    &--visible {
      opacity: 1;
      pointer-events: all;
    }
  }
</style>
